import React from 'react';
import { motion } from 'framer-motion';
import { Trophy } from 'lucide-react';
import { AppState } from '../../app/types';
import { GroupId } from '../../config/systemConfig';
import { getRecentMilestones } from '../../utils/activityHelpers';
import { Card } from '../ui/Card';
import { itemVariants } from '../shared/animations';
interface MilestonesSectionProps {
  state: AppState;
  selectedGroup: GroupId;
}
export function MilestonesSection({
  state,
  selectedGroup
}: MilestonesSectionProps) {
  const milestones = getRecentMilestones(state, selectedGroup);
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'level_up':
        return 'bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200 text-blue-800';
      case 'subject_complete':
        return 'bg-gradient-to-br from-amber-50 to-amber-100 border-amber-300 text-amber-800 shadow-amber-100';
      case 'streak':
        return 'bg-gradient-to-br from-orange-50 to-orange-100 border-orange-200 text-orange-800';
      case 'first_practice':
        return 'bg-gradient-to-br from-emerald-50 to-emerald-100 border-emerald-200 text-emerald-800';
      default:
        return 'bg-gradient-to-br from-slate-50 to-slate-100 border-slate-200 text-slate-800';
    }
  };
  return <div className="space-y-4" data-id="element-1865">
      <div className="flex items-center gap-3" data-id="element-1866">
        <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0" data-id="element-1867">
          <Trophy className="w-5 h-5 text-amber-600" data-id="element-1868" />
        </div>
        <h2 className="text-xl font-black text-slate-800" data-id="element-1869">Mijn Mijlpalen</h2>
      </div>

      {milestones.length === 0 ? <Card className="p-6 text-center bg-slate-50 border-dashed border-2 border-slate-200 rounded-2xl shadow-sm" data-id="element-1870">
          <p className="text-slate-500 font-medium" data-id="element-1871">
            Ga oefenen om je eerste mijlpaal te verdienen! 🎯
          </p>
        </Card> : <div className="flex overflow-x-auto pb-4 -mb-4 gap-4 snap-x snap-mandatory scrollbar-hide -mx-3 px-3 sm:mx-0 sm:px-0" data-id="element-1872">
          {milestones.map((milestone, i) => <motion.div key={`${milestone.type}-${milestone.timestamp}-${i}`} variants={itemVariants} className="min-w-[60%] sm:min-w-0 snap-start flex-shrink-0" data-id="element-1873">
              <Card className={`p-4 flex items-center gap-4 border-2 rounded-2xl ${getTypeColor(milestone.type)} shadow-sm hover:shadow-md transition-shadow`} data-id="element-1874">
                <div className="text-3xl bg-white/80 w-14 h-14 rounded-full flex items-center justify-center shadow-sm flex-shrink-0" data-id="element-1875">
                  {milestone.emoji}
                </div>
                <div className="flex-1 min-w-0" data-id="element-1876">
                  <p className="font-bold text-sm leading-snug" data-id="element-1877">
                    {milestone.label}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </div>}
    </div>;
}